<template>
  <b-modal :id="modalId" title="Apply WhatsApp Template" size="lg" hide-footer>
    <!-- Filters -->
    <div class="row mb-3">
      <div class="col-sm-4">
        <div class="search-box mr-2 mb-2 d-inline-block">
          <div class="position-relative">
            <input v-model="searchQuery" type="text" class="form-control" placeholder="Search..."/>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- / Filters -->

    <div class="text-center">
      <b-spinner v-if="isLoading||searchQueryIsDirty" class="m-2" variant="itg-dark" role="status"></b-spinner>
    </div>

    <table v-if="!(isLoading||searchQueryIsDirty)" class="table table-striped table-centered">
      <tbody>
        <tr v-for="template in templateResults" :key="template.id">
          <th scope="row">{{ template.name }}</th>
          <td>{{ template.body }}</td>
          <td class="text-right">
            <a href="#" @click="applyTemplate(template)" class="btn btn-sm btn-itg">Apply</a>
          </td>
        </tr>
        <tr v-if="templateResults.length === 0">
          <th scope="row" colspan="3">
            <span class="text-danger">No results</span>
          </th>
        </tr>
      </tbody>
    </table>

    <pagination v-if="!(isLoading||searchQueryIsDirty)" :data="templates" :limit="8"
                @pagination-change-page="loadTemplates"></pagination>
  </b-modal>
</template>

<script>
import Forms from "../../../../../../mixins/Forms";
import axios from "axios";

export default {
  name: "ApplyTicketWhatsappTemplateModal",
  mixins: [Forms],
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      serverErrors: [],
      templates: [],
      searchQuery: '',
      searchQueryIsDirty: false
    };
  },
  created() {
    this.loadTemplates();
  },
  watch: {
    searchQuery: function () {
      this.searchQueryIsDirty = true;
      this.loadTemplates();
    }
  },
  computed: {
    templateResults() {
      if (this.templates) {
        return this.templates.data;
      }
      return [];
    }
  },
  methods: {
    loadTemplates(page = 1) {
      let vm = this;
      vm.isLoading = true;
      vm.serverErrors = [];

      axios.post(API_BASE + '/ticket-whatsapp-templates/search', {
        page: page,
        results_per_page: 5,
        q: vm.searchQuery
      })
        .then((r) => {
          vm.isLoading = false;
          vm.templates = r.data;
          vm.searchQueryIsDirty = false;
        })
        .catch((e) => {
          vm.isLoading = false;
          vm.setErrors(e);
        });
    },

    applyTemplate(template) {
      this.$emit("template-selected", template);
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>